import { api } from '@/lib/api-client'
import { SkywardAccount, SkywardSite } from '@/types/skyward-types'
import { logger } from '../lib/logger'

// Site API

// Connection API
export type SkywardConnectPayload = {
  identifier?: string
  nameId?: string
  code?: string
  entityId?: string
  orgId?: number
  userId?: number
  referrer?: string
  sessionId?: string
}

export type SkywardConnectResponse = {
  sessionId?: string
  userId?: string
  tenantId?: string
  nameId?: string
  validationId?: string
  accounts?: {
    customerId: string
    customerOtherId: string
    customerNameId: string
    staff: boolean
    allowFood: boolean
    allowFee: boolean
  }[]
  site: SkywardSite
}

export const fetchSkywardSite = async (id: number): Promise<SkywardSite> => {
  if (!id) throw new Error('No site id found')

  // API returns SkywardSite directly (no Result<T> wrapper)
  return await api.get<SkywardSite>(`skyward/site/${id}`).json()
}

export const skywardConnect = async (payload?: SkywardConnectPayload): Promise<SkywardConnectResponse> => {
  try {
    const response = await api.post('skyward/connect', { json: payload })
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: Failed to connect to Skyward`)
    }
    // API returns SkywardConnectResponse directly (no Result<T> wrapper)
    return (await response.json()) as SkywardConnectResponse
  } catch (error) {
    logger.error('Error connecting to Skyward:', error)
    // Re-throw the original error if it has a message, otherwise wrap it
    if (error instanceof Error) {
      throw error
    }
    throw new Error('Failed to connect to Skyward', { cause: error })
  }
}

// Accounts API
export const fetchSkywardAccounts = async (): Promise<SkywardAccount[]> => {
  logger.info('Fetching Skyward accounts')
  try {
    // API returns SkywardAccount[] directly (no Result<T> wrapper)
    return await api.get<SkywardAccount[]>('skyward/accounts').json()
  } catch (error) {
    console.error('Error fetching Skyward accounts:', error)
    throw new Error('Failed to get Skyward accounts', { cause: error })
  }
}
